export const MULO_CONTAINER_WIDTH = {
  SLIM: 780,
  READING: 870,
  STANDARD: 960,
  WIDE: 1180,
};
